import React from 'react';
import { SlideOutButton } from 'resources/js/personas/byron/header/SlideOutButton';
import VerticalMenu from 'resources/js/personas/shared/components/Menu/VerticalMenu';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import {
  HeaderMenu,
  HeaderSocials
} from 'resources/js/personas/byron/header/HeaderBlock';
import HamburgerMenuIcon from './icons/v2HamburgerMenu.svg';
import { SocialContactsTS } from 'resources/js/personas/shared/components/social-contacts/SocialContactsTS';

const hamburgerMenuDefaultStyles = StyleSheet({
  desktopHamburgerMenu: {
    display: 'none',
    flex: 1,
    boxSizing: 'border-box',
    width: 'auto',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',

    '@media(max-width: 1024px)': {
      display: 'flex'
    }
  },
  hamburgerWithSocials: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
    height: '100%',
    padding: '0 20px',
    gap: '16px'
  },
  socialIconsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    '& > a > svg': {
      width: '18px',
      height: '18px'
    }
  }
});

interface Props {
  menuBackgroundColor: string;
  transparentFontColor: string;
  menuFontColor: string;
  menuFontHoverColor: string;
  menu: HeaderMenu;
  isTransparent: boolean;
  navMenuOverflowing: boolean;
  forceBurgerMenu?: boolean;
  showSocialsInMinimalMenu?: boolean;
  socials?: HeaderSocials;
}

export function HamburgerMenu(props: Props) {
  const {
    menuBackgroundColor,
    transparentFontColor,
    menuFontColor,
    menuFontHoverColor,
    menu,
    isTransparent,
    navMenuOverflowing,
    forceBurgerMenu,
    showSocialsInMinimalMenu,
    socials
  } = props;
  const s = useStyles(hamburgerMenuDefaultStyles);
  // Check if we should show social icons (force burger menu enabled, show socials enabled, and socials provided)
  const shouldShowSocials =
    forceBurgerMenu && showSocialsInMinimalMenu && socials;

  const slideOutButton = (
    <SlideOutButton
      Icon={HamburgerMenuIcon}
      paneDirection={'right'}
      backgroundColor={menuBackgroundColor}
      headerBackgroundColor={menuBackgroundColor}
      hamburgerColor={isTransparent ? transparentFontColor : menuFontColor}
      content={
        <VerticalMenu
          menuFontColor={menuFontColor}
          menuFontHoverColor={menuFontHoverColor}
          menu={menu}
          menuBackgroundColor={menuBackgroundColor}
        />
      }
    />
  );

  return (
    <div
      {...s.with('desktopHamburgerMenu')(
        navMenuOverflowing || forceBurgerMenu
          ? {
              display: 'flex'
            }
          : {}
      )}
    >
      {shouldShowSocials ? (
        <div {...s('hamburgerWithSocials')}>
          <div {...s('socialIconsContainer')}>
            <SocialContactsTS
              socialLinks={socials}
              overrideColor={
                isTransparent ? transparentFontColor : menuFontColor
              }
              menuFontHoverColor={menuFontHoverColor}
            />
          </div>
          <div style={{ flexShrink: 0 }}>{slideOutButton}</div>
        </div>
      ) : (
        slideOutButton
      )}
    </div>
  );
}
